import { InvalidContractPropertyStateError } from '../errors';
export var ContractPropertyStateModel;
(function (ContractPropertyStateModel) {
    ContractPropertyStateModel[ContractPropertyStateModel["NoProperty"] = 0] = "NoProperty";
    ContractPropertyStateModel[ContractPropertyStateModel["HasStorage"] = 1] = "HasStorage";
    ContractPropertyStateModel[ContractPropertyStateModel["HasDynamicInvoke"] = 2] = "HasDynamicInvoke";
    ContractPropertyStateModel[ContractPropertyStateModel["Payable"] = 4] = "Payable";
    ContractPropertyStateModel[ContractPropertyStateModel["HasStorageDynamicInvoke"] = 3] = "HasStorageDynamicInvoke";
    ContractPropertyStateModel[ContractPropertyStateModel["HasStoragePayable"] = 5] = "HasStoragePayable";
    ContractPropertyStateModel[ContractPropertyStateModel["HasDynamicInvokePayable"] = 6] = "HasDynamicInvokePayable";
    ContractPropertyStateModel[ContractPropertyStateModel["HasStorageDynamicInvokePayable"] = 7] = "HasStorageDynamicInvokePayable";
})(ContractPropertyStateModel || (ContractPropertyStateModel = {}));
export const HasStorage = new Set([
    ContractPropertyStateModel.HasStorage,
    ContractPropertyStateModel.HasStorageDynamicInvoke,
    ContractPropertyStateModel.HasStoragePayable,
    ContractPropertyStateModel.HasStorageDynamicInvokePayable,
]);
export const HasDynamicInvoke = new Set([
    ContractPropertyStateModel.HasDynamicInvoke,
    ContractPropertyStateModel.HasStorageDynamicInvoke,
    ContractPropertyStateModel.HasDynamicInvokePayable,
    ContractPropertyStateModel.HasStorageDynamicInvokePayable,
]);
export const HasPayable = new Set([
    ContractPropertyStateModel.Payable,
    ContractPropertyStateModel.HasStoragePayable,
    ContractPropertyStateModel.HasDynamicInvokePayable,
    ContractPropertyStateModel.HasStorageDynamicInvokePayable,
]);
const isContractPropertyState = (value) => ContractPropertyStateModel[value] !== undefined;
export const assertContractPropertyState = (value) => {
    if (isContractPropertyState(value)) {
        return value;
    }
    throw new InvalidContractPropertyStateError(value);
};
export const getContractProperties = ({ hasStorage, hasDynamicInvoke, payable, }) => {
    if (hasStorage && hasDynamicInvoke && payable) {
        return ContractPropertyStateModel.HasStorageDynamicInvokePayable;
    }
    if (hasStorage && hasDynamicInvoke) {
        return ContractPropertyStateModel.HasStorageDynamicInvoke;
    }
    if (hasStorage && payable) {
        return ContractPropertyStateModel.HasStoragePayable;
    }
    if (hasDynamicInvoke && payable) {
        return ContractPropertyStateModel.HasDynamicInvokePayable;
    }
    if (hasDynamicInvoke) {
        return ContractPropertyStateModel.HasDynamicInvoke;
    }
    if (hasStorage) {
        return ContractPropertyStateModel.HasStorage;
    }
    if (payable) {
        return ContractPropertyStateModel.Payable;
    }
    return ContractPropertyStateModel.NoProperty;
};

//# sourceMappingURL=ContractPropertyStateModel.js.map
